/**
 * Encode each path segment for safe use in URLs (spaces, special chars).
 */
function encodeAssetPath(assetPath) {
  return String(assetPath)
    .trim()
    .replace(/^\/+/, "")
    .split("/")
    // encodeURIComponent leaves ( ) ' ! * alone; "(" / ")" in names like
    // "background_(1).jpg" break unquoted CSS url(...) values, so encode them too.
    .map((segment) =>
      encodeURIComponent(segment).replace(
        /[()'!*]/g,
        (c) => `%${c.charCodeAt(0).toString(16).toUpperCase()}`
      )
    )
    .join("/");
}

/** CSS `url("...")` value for an asset (or "" when there is none). */
export function s3CssUrl(asset) {
  const url = s3PublicUrl(asset);
  return url ? `url("${url.replace(/"/g, "%22")}")` : "";
}

/**
 * Build a public S3 URL for a theme asset filename.
 * Passes through values that are already absolute URLs.
 */
export function s3PublicUrl(asset) {
  if (asset == null || asset === "") return "";
  const s = String(asset).trim();
  if (/^https?:\/\//i.test(s)) return s;
  const baseRaw =
    process.env.REACT_APP_S3_PATH || process.env.REACT_APP_S3_SOURCE || "";
  if (!baseRaw) return encodeAssetPath(s);
  const normalizedBase = baseRaw.endsWith("/") ? baseRaw : `${baseRaw}/`;
  return normalizedBase + encodeAssetPath(s);
}
